<template>
  <div>
    <el-tree
      :data="data"
      show-checkbox
      ref="treeRef"
      node-key="id"
      :default-expanded-keys="[1]"
      @check="checkChange"
      :expand-on-click-node="false"
      :default-checked-keys="checkedData"
    >
      <!-- @node-click="btnKey" -->
      <!-- @check-change="true" -->
      <span class="custom-tree-node" slot-scope="{ data }">
        <span class="tree-text">{{ data.label }}</span>
      </span>
    </el-tree>
  </div>
</template>

<script>
import * as apiExam from "@/api/exam/question";
let id = 1000;
export default {
  props: ["checkedData",'lianxi','deptId'],
  data() {
    const data = [];
    return {
      data: JSON.parse(JSON.stringify(data)),
      dialogVisible: false,
      dialogVisibleUpdate: false,
      info: {},
      inputType: "",
      treeList: [],
      // deptID: JSON.parse(this.$store.state.User.infos).deptId,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    checkChange(data, checke) {
      this.treeList = this.$refs.treeRef.getCheckedNodes();
      this.$emit("btnKey", this.treeList);
    },
    handleCloseUpdate() {
      this.dialogVisibleUpdate = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    btnKey(data, node) {
      this.$emit("btnKey", data.id);
    },
    getList() {
      let data = {
        deptId: this.deptId,
      };
      if (this.lianxi) {
        data.lianxi = this.lianxi;
      }
      apiExam.getTree(data).then((res) => {
        this.data = [res.result];
      });
    },
    submitUpdate() {
      this.dialogVisible = false;
    },
    submitAdd() {
      let data = this.info;
      const newChild = { id: id++, name: this.inputType, children: [] };
      if (!data.children) {
        this.$set(data, "children", []);
      }
      data.children.push(newChild);
      this.dialogVisible = false;
    },
  },
  watch: {
    // 简单监听
    deptId(newVal, oldVal) {
      console.log(oldVal,newVal);
      this.getList();
    },
  }
};
</script>
<style lang="scss" scoped>
.tree-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style >
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.el-tooltip__popper.is-dark {
  font-size: 14px;
}
.hover-color {
  color: #b7b9bf;
  margin-left: 10px;
}
.hover-color:hover {
  color: red;
}
</style>